import PropTypes from "prop-types";
import { OverlayTrigger, Tooltip as BSTooltip } from "react-bootstrap";

import { alertCircleIcon } from "assets/icons";

export const Tooltip = ({
  children = <img src={alertCircleIcon} className="info-icon" />,
  value,
  placement = "right",
  tooltipClassName,
  delay = 100,
}) => {
  const renderTooltip = (props) => {
    return value ? (
      <BSTooltip {...props}>
        <span>{value}</span>
      </BSTooltip>
    ) : (
      <span />
    );
  };

  return (
    <OverlayTrigger
      placement={placement}
      delay={{ show: 100, hide: delay }}
      overlay={(props) =>
        renderTooltip({ ...props, className: tooltipClassName })
      }
    >
      <span style={{ width: "fit-content" }} data-html={true}>
        {children}
      </span>
    </OverlayTrigger>
  );
};

Tooltip.propTypes = {
  value: PropTypes.oneOfType([
    PropTypes.string,
    PropTypes.number,
    PropTypes.object,
  ]),
  children: PropTypes.node,
  placement: PropTypes.string,
  tooltipClassName: PropTypes.string,
  delay: PropTypes.number,
};
